import { billing } from "../api";
import { useSubscriptionStore } from "../store/zustand/useSubscriptionStore";
import { displayOrCatchMessage } from "./index";

const fetchSubscription = () => {
  billing
    .isSubscribed()
    .then((data) => {
      useSubscriptionStore.getState().setSubscription(data);
    })
    .catch((e) => displayOrCatchMessage(e));
};

export default fetchSubscription;
